import Config from "../config/constants";
import axios, { AxiosResponse } from 'axios';


export const apiPatchPointConfig = async (params: any, accessToken: string) => {
  const url = `${Config.API_HOST}/api/app/point/pointconfig`;
  console.log(url);
  try {
    const response = await axios.patch(url, params, { headers: { access_token: accessToken } });
    return response.data;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};

export const apiGetPointConfig = async (accessToken: string): Promise<AxiosResponse> => {
  const url = `${Config.API_HOST}/api/app/point/pointconfig`;

  try {
    const response = await axios.get(url, { headers: { access_token: accessToken } });
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const apiGetSPointList = async (params: any, accessToken: string): Promise<AxiosResponse> => {
  const url = `${Config.API_HOST}/api/app/shopping-point/list`;

  try {
    const response = await axios.get(url, {
      headers: { access_token: accessToken },
      params: params,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const apiGetMTokenList = async (params: any, accessToken: string): Promise<AxiosResponse> => {
  const url = `${Config.API_HOST}/api/app/mtoken-transfer/list`;

  try {
    const response = await axios.get(url, {
      headers: { access_token: accessToken },
      params: params,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const apiDoTokenTransfer = async (params: any, id: number, accessToken: string): Promise<AxiosResponse> => {

  const url = `${Config.API_HOST}/api/app/mtoken-transfer/update/${id}`;

  try {
    const response = await axios.patch(url, params, {
      headers: { access_token: accessToken }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const apiDoShoppingStatus = async (params: any, id: number, accessToken: string): Promise<AxiosResponse> => {

  const url = `${Config.API_HOST}/api/app/shopping-point/update/${id}`;

  try {
    const response = await axios.patch(url, params, {
      headers: { access_token: accessToken }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const apiGetCafe24PointConversionList = async (
  params: any,
  accessToken: string
): Promise<AxiosResponse> => {
  const url = `${Config.API_HOST}/api/admin/cafe24-point-conversions/list`;

  try {
    const response = await axios.get(url, {
      headers: { access_token: accessToken },
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching cafe24 point conversions:", error);
    throw error;
  }
};


export const apiGivePoint = async (params: any, accessToken: string): Promise<AxiosResponse> => {

  const url = `${Config.API_HOST}/api/admin/point/insert`;

  try {
    const response = await axios.post(url, params, {
      headers: { access_token: accessToken }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};